export default "__VITE_ASSET__e9ScJH9e__"